<div id="alert" class="alert-box move-out">
  <div class="alert-box-content" [ngClass]="alert.type">
    <div><span>{{alert.title}}</span></div>
    <div>{{alert.content}}</div>
  </div>
</div>
